module.exports = __webpack_public_path__ + "76d76579677aafe9c87f45d3bf65a5a7.svg";